import { createRoot } from 'react-dom/client'
import createModal from './createModal'

/**
 * @callback CreateComponent
 * @param {Modal} modal
 */

export const CONTENT_WITH_FOOTER = true
export const MODAL_SIZE = {
  XL: 'modal-xl',
  XS: 'modal-xs',
  LG: 'modal-lg',
  MD: 'modal-md',
}

/**
 * Renders given react component in Modal instance.
 *
 * @param {CreateComponent} createComponent Returns component
 * @param {{ title?: string|null, contentWithFooter?: boolean, contentSizeClass?: string, suppressModalBodyClassName?: boolean }} options
 * @returns {Modal}
 */
export default function createReactModal (createComponent, {
  title = null,
  contentWithFooter = false,
  contentSizeClass = MODAL_SIZE.LG,
  suppressModalBodyClassName = false,
}) {
  const modal = createModal(title, '', contentWithFooter, contentSizeClass)

  // Find the root
  const reactRoot = contentWithFooter === true ? modal.$content[0] : modal.$content.find('.modal-body')[0]
  const root = createRoot(reactRoot)
  suppressModalBodyClassName && modal.$content.find('.modal-body')[0] && (
    modal.$content.find('.modal-body')[0].className = ''
  )

  contentWithFooter === false && modal.$content.find('.modal-footer').remove()

  // Unmount the components
  modal.onHide = () => { root.unmount() }

  // Create component and render
  root.render(createComponent(modal))

  return modal
}
